/**
 * Created by Mark on 17/04/2017.
 */

import BaseStore from './base-store.js';
import React from 'react';
import Constants from  '../constants/languages'
import Language  from  '../classes/language.js';

class LanguageStore extends BaseStore {

    constructor(){
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.languages = [];
        this.interface = [];
    }


    _processLanguages(languages){
        var languageObjects = {};

        if (languages == undefined){
            return [];
        }
        
        for(var idx = 0 ; idx < languages.length; idx++)
        {
            var language = languages[idx];
            if(language.isInterface == "1") continue;

            if(languageObjects[language.ietf] && languageObjects[language.ietf].isInterface == "0"){
                languageObjects[language.ietf].addCurriculum(language.curriculumUid , language.packageUid ,language.curriculum_name)
                continue;
            }

            languageObjects[language.ietf] = new Language(language.name , language.ietf ,  language.isInterface , language.name , language.hasSpeaking);
            languageObjects[language.ietf].addCurriculum(language.curriculumUid , language.packageUid , language.curriculum_name )
            languageObjects[language.ietf].isPriority = language.isPriority;
        }

        return languageObjects;
    }

    _processInterfaceLanguages(languages){
        var languageObjects = {};


        for(var idx = 0 ; idx < languages.length; idx++)
        {
            var language = languages[idx];
            if(language.isInterface == "0") continue;

            if(languageObjects[language.ietf] && languageObjects[language.ietf].isInterface == "0"){
                languageObjects[language.ietf].addCurriculum(language.curriculumUid , language.packageUid ,language.curriculum_name)
                continue;
            }

            languageObjects[language.ietf] = new Language(language.name , language.ietf ,  language.isInterface , language.name , language.hasSpeaking);
            languageObjects[language.ietf].addCurriculum(language.curriculumUid , language.packageUid , language.curriculum_name )
            languageObjects[language.ietf].isPriority = language.isPriority;
        }

        return languageObjects;
    }

    _registerToActions(action) {

        switch(action.actionType)
        {
            case Constants.ALL_LANGUAGES_UPDATE :
                this.languages = this._processLanguages(action.response);
                this.interfaceLanguage = this._processInterfaceLanguages(action.response);
                this.emitChange();
                break;
            case Constants.CURR_LANGUAGES_UPDATE:
                this.currLanguages = this._processLanguages(action.response);
                break;
        }
    }

    getLanguageArr(){
        return Object.keys(this.languages).map(function(k) { return this.languages[k] }.bind(this));
    }

    getInterfaceLanguageArr(){
        return Object.keys(this.interfaceLanguage).map(function(k) { return this.interfaceLanguage[k] }.bind(this));
    }

    getLearningLanguage(){
        var arr = this.getLanguageArr();

        var response = [];
        for(var idx = 0; idx < arr.length; idx++) if(arr[idx].isInterface == "0") response.push(arr[idx]);

        response.sort(function(a, b){return Number(b.isPriority)- Number(a.isPriority)});

        return response;
    }

    getSupportLanguage(){
        var arr = this.getLanguageArr();
        var response = [];
        for(var idx = 0; idx < arr.length; idx++) if(arr[idx].isEal) response.push(arr[idx]);
        return arr;
    }
    
    getInterfaceLanguage() {
        var arr = this.getInterfaceLanguageArr();
        var response = [];
        for(var idx = 0; idx < arr.length; idx++) if(arr[idx].isEal) response.push(arr[idx]);
        return arr;
    }

    getCurriculumsFor(ietf){
        if(this.languages[ietf]) return this.languages[ietf].curriculums;
        return [];
    }

    getLanguage(ietf){
        return this.languages[ietf];
    }

    getLanguageInterface(ietf){
        return this.interfaceLanguage[ietf];
    }

}

export default new LanguageStore();


// WEBPACK FOOTER //
// ./src/store/language-store.js